import { render, staticRenderFns } from "./zhiyebiangeng.vue?vue&type=template&id=49f6691d&scoped=true"
import script from "./zhiyebiangeng.vue?vue&type=script&lang=js"
export * from "./zhiyebiangeng.vue?vue&type=script&lang=js"
import style0 from "./zhiyebiangeng.vue?vue&type=style&index=0&id=49f6691d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f6691d",
  null
  
)

export default component.exports